import React, { forwardRef, useEffect, useState } from 'react';
import styles from './GenericOrganisationSearchForBranch.module.scss';
import orgSearchService from './GenericOrganisationForBranchService';
import { validate, isCompleted } from '../Utils/Validation';
import { Notification, ComponentLoader, Button, FormInput } from '@snsw/react-component-library';
import abnAcnService from '../OrganisationAbnAcn/OrganisationAbnAcnService';
import { number } from 'prop-types';

const GenericOrganisationSearchForBranch = (props, ref) => {
  const [isValid, setIsValid] = useState(false);
  const [isAbr, setIsAbr] = useState(false);
  const [isOther, setIsOther] = useState(false);
  const [businessName, setBusinessName] = useState('');
  const [registrationNumber, setRegistrationNumber] = useState('false');
  const [loaded, setLoaded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showResult, setShowResult] = useState(false);
  const [currentNumber, setCurrentNumber] = useState(props.number || '');

  const clearResult = (clear = false) => {
    setIsValid(undefined);
    setLoaded(false);
    props.setData('');
    if (props.onClearClick && clear) {
      props.onClearClick();
    }
  };

  useEffect(() => {
    setShowResult(false);
    clearResult();
  }, [currentNumber]);

  useEffect(() => {
    if (currentNumber) {
      handleLookup(currentNumber);
    }
  }, []);

  useEffect(() => {
    if (props.onValidationChange) {
      props.onValidationChange(!!loaded && isValid);
    }
  }, [showResult, loaded, isValid]);

  const retrieveValue = (searchValue) => {
    setLoading(true);
    setLoaded(false);
    setIsValid(undefined);
    setBusinessName('');
    setRegistrationNumber('');

    orgSearchService
      .search(`${props.url}?registrationNumber=${searchValue}&regoType=${props.regoType}`)
      .then((response) => {
        const data = response?.data;
        if (data.isValid) {
          return {
            isAbr: false,
            ...data
          };
        } else if (props.regoType === 'ABN' || props.regoType === 'ACN') {
          if (props.regoType === 'ABN') {
            return abnAcnService.search(`${props.abnUrl}`, searchValue).then((response) =>
              response?.data?.length
                ? {
                    ...response?.data[0],
                    isValid: true,
                    isAbr: true,
                    businessName: response?.data[0].name,
                    registrationNumber: response?.data[0].abn
                  }
                : { isValid: false }
            );
          } else {
            return abnAcnService.search(`${props.acnUrl}`, searchValue).then((response) =>
              response?.data?.length
                ? {
                    ...response?.data[0],
                    isValid: true,
                    isAbr: true,
                    businessName: response?.data[0].name,
                    registrationNumber: response?.data[0].abn
                  }
                : { isValid: false }
            );
          }
        } else {
          return data;
        }
      })
      .then((data) => {
        console.log('response 2: ', data);
        setShowResult(true);
        setErrors({
          ...errors,
          apiError: false
        });
        setIsOther(props.regoType !== 'ABN' && props.regoType !== 'ACN');
        setIsValid(!!data.isValid);
        setIsAbr(!!data.isAbr);
        setBusinessName(data.businessName);
        setRegistrationNumber(data.registrationNumber);
        if (props.setData) {
          props.setData(data);
        }
        setLoaded(true);
      })
      .catch((err) => {
        console.log('The reject', err);
        setShowResult(false);
        setErrors({
          ...errors,
          apiError: true
        });
        setIsValid(false);
        if (props.setData) {
          props.setData([]);
        }
        setLoaded(false);
      })
      .then(() => {
        setLoading(false);
      });
  };

  const handleLookup = () => retrieveValue(currentNumber);

  ///Rules for trading name: 1. show 'Same as above' 1st. 2. combine the tradingName and businessName together from ABR.
  const transformNames = (businessNames, tradingNames) => {
    return [defaultTradingName]
      .concat((businessNames || []).map((label) => ({ value: label, label })))
      .concat((tradingNames || []).map((label) => ({ value: label, label })));
  };

  const [showErrors, setShowErrors] = useState(false);
  const [errors, setErrors] = useState({
    apiError: false,
    currentNumber: false
  });
  const validators = [
    {
      fieldName: 'apiError',
      fieldValue: errors,
      isValid: ({ apiError }) => apiError
    },
    {
      fieldName: 'currentNumber',
      fieldValue: currentNumber,
      isValid: (v) => isCompleted(v) && isValid
    }
  ];

  useEffect(() => {
    if (currentNumber.length >= 1) {
      setShowErrors(false);
    }
  }, [currentNumber]);

  if (ref) {
    ref.current = {
      validate: () => {
        const isValid = validate(validators, setErrors);
        setShowErrors(!isValid);
      },
      clear: clearResult
    };
  }

  return (
    <div className={styles.mainContainer}>
      {props.title && (
        <div className={'row'}>
          <div className={`col-12`}>
            <label className={styles.title} htmlFor={'currentNumberInput'}>
              {props.title}
            </label>
          </div>
        </div>
      )}
      <div className={`row ${styles.searchBox}`}>
        <div className={styles.searchInput}>
          <FormInput
            id={'currentNumberInput'}
            placeholder={props.type}
            value={currentNumber}
            onChange={async (e) => {
              const isAbnAcn = props.regoType === 'ABN' || props.regoType === 'ACN';
              const regex = isAbnAcn ? /\D/g : /\W\ /g;
              const maxChars = isAbnAcn ? 11 : 30;
              let numericVals = e.target.value.replace(regex, '');
              if (numericVals.length > maxChars) {
                numericVals = numericVals.substring(0, maxChar);
              }
              setCurrentNumber(numericVals);
              if (props.setNumber) {
                props.setNumber(numericVals);
              }
            }}
          />
        </div>
        <div className={styles.searchButton}>
          <Button
            theme="secondary"
            disabled={!currentNumber || !props.regoType}
            onClick={() => {
              if (currentNumber && props.regoType) {
                handleLookup();
              }
            }}
            onKeyDown={(e) => {
              if (currentNumber && props.regoType && e.keyCode === 13) {
                handleLookup();
              }
            }}
          >
            Search
          </Button>
        </div>
      </div>
      {showErrors && errors.apiError ? (
        <div className={'row'}>
          <div className={`col-12`}>
            <Notification variant="error" title={`Registration Number is required.`} />
          </div>
        </div>
      ) : null}
      {loading && <ComponentLoader className={`${styles.loading} ${props.title ? styles.loadingWithTitle : ''}`} />}
      {showResult && !!loaded && isValid ? (
        props.showDetailOnSuccess ? (
          <div className={'row'}>
            <div className={`col-12`}>
              <div className={styles.detail} id={'abnAcnSearchResult'}>
                <div className={styles.titleLine}>
                  <h3 className={styles.titleLeft}>{businessName}</h3>
                  <div className={styles.titleRight}>
                    <a
                      href={'#'}
                      onClick={(e) => {
                        e.preventDefault();
                        clearResult(true);
                      }}
                    >
                      Clear
                    </a>
                  </div>
                </div>
                <div className={styles.detailLine}>
                  <div className={styles.detailLeft}>{props.title}</div>
                  <div className={styles.detailRight}>{registrationNumber}</div>
                </div>
                {isAbr ? (
                  <div className={styles.buttonInWarningCont}>
                    <Button
                      variant={'secondary'}
                      onClick={(e) => {
                        if (props.onAlternativeFlowClick) {
                          props.onAlternativeFlowClick(e);
                        }
                      }}
                    >
                      {props.createButtonCopy ?? 'Create a branch'}
                    </Button>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        ) : (
          <Notification variant="success" title={`Record matched successfully.`} />
        )
      ) : null}
      {!!loaded && !isValid && (typeof props.showError === 'undefined' || props.showError === true) ? (
        isOther ? (
          <div className={'row'}>
            <div className={`col-12`}>
              <div className={styles.detail} id={'abnAcnSearchResult'}>
                <div className={styles.titleLine}>
                  <h3 className={styles.titleLeft}>No results for {currentNumber}</h3>
                  <div className={styles.titleRight}>
                    <a
                      href={'#'}
                      onClick={(e) => {
                        e.preventDefault();
                        clearResult(true);
                      }}
                    >
                      Clear
                    </a>
                  </div>
                </div>
                <div className={styles.buttonInWarningCont}>
                  <Button
                    variant={'secondary'}
                    onClick={(e) => {
                      if (props.onAlternativeFlowClick) {
                        props.onAlternativeFlowClick(e);
                      }
                    }}
                  >
                    {props.createButtonCopy ?? 'Create a branch'}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className={'row'}>
            <div className={`col-12`}>
              <Notification
                variant="error"
                title={
                  props?.errors && props?.errors[props.regoType.toLowerCase()]
                    ? props?.errors[props.regoType.toLowerCase()]
                    : `The number entered is not a valid ${props.regoType}.`
                }
              />
            </div>
          </div>
        )
      ) : null}
    </div>
  );
};

export default forwardRef(GenericOrganisationSearchForBranch);
